import { ImmutableMap, QueryParams } from './utility.model';

export const SKIP_TYPES = ['none', 'condition', 'manual', 'force'] as const;
export type SkipTypes = (typeof SKIP_TYPES)[number];

export const STEP_RESULT_TYPES = ['yesno', 'select', 'digit', 'naturalNumber', 'none'] as const;
export type StepResultTypes = (typeof STEP_RESULT_TYPES)[number];

export const UPLOAD_STATUS = ['in-progress', 'decoding', 'failed', 'succeed'] as const;
export type UploadStatus = (typeof UPLOAD_STATUS)[number];

export type ResultVideo = {
  name: string;
  upload: UploadStatus;
};

type ResultVoice = {
  name: string;
  upload: UploadStatus;
};

export type ResultImage = {
  name: string;
  upload: UploadStatus;
};

type StepOptionalProps = {
  result?: string;
  startedAt?: number;
  stoppedAt?: number;
  userId?: string;
  userName?: string;
  deviceName?: string;
  count?: number;
  skip?: SkipTypes;
};

type StepProvidedProps = {
  workId: string;
  step: number;
  organizationId: string;
  no: number;
  type: 'question';
  segment: string;
  title: string;
  body: string;
  resultType: StepResultTypes;
  skipCondition: string;
  addGuideCondition: string;
  addGuidebody: string;
  outputCondition: number;
  photoOutputCondition: number;
  hash: string;
  videos?: ResultVideo[];
  voice?: ResultVoice;
  images?: ResultImage[];
  editor: string;
  editorName: string;
  updatedAt: number;
  version: number;
};

export type StepQueryParams = QueryParams & { organizationId?: string; reportId: string; workId: string };

export type ListVideoQueryParams = QueryParams & { reportId: string; workId: string; step: number };

export type VoiceQueryParams = QueryParams & { reportId: string; workId: string; step: number };

export type ImageQueryParams = QueryParams & { reportId: string; workId: string; step: number; name: string };

export type Step = StepOptionalProps & StepProvidedProps;

export type StepUpdateParams = StepOptionalProps;

export type ResultReportLabels = {
  attendanceDateAndTime: string;
  engineer: string;
  customer: string;
  continue: string;
  photo: string;
  summary: string;
};
export type ResultReportCreateParams = {
  workName: string;
  manualName: string;
  steps: Step[];
  imageContents: ImageContent[];
  summary: string;
  labels: ResultReportLabels;
  lang: string;
};
export type ImageContent = {
  no: number;
  count: number;
  title: string;
  dataUrl: string;
  width: number;
  height: number;
};

export class Steps extends ImmutableMap<string, Step> {
  constructor(steps?: Step[] | Iterable<Step>) {
    super((step: Step) => `${step.workId}_${step.step}`, steps);
  }

  protected clone(steps?: Step[] | Iterable<Step>): this {
    return new Steps(steps) as this;
  }
}
